import PropTypes from "prop-types";
import React from "react";

export class NavTab extends React.Component {

    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(event) {
        event.preventDefault();
        this.props.doSelect();
    }

    render() {
        const { className, active = false, name} = this.props;

        let classes = className;

        if (active) {
            classes += " active";
        }

        return (
            <li className={classes}>
                <a onClick={this.handleClick}
                   href="#">
                    <span></span>{name}
            </a>
            </li>
        );
    }
}

NavTab.propTypes = {
    doSelect: PropTypes.func.isRequired,
    active: PropTypes.bool.isRequired,
    className: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./app/lib/common/navtabs/NavTab.js